import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "sort"
})
export class SortPipe implements PipeTransform {
  transform<T>(data: T[], prop: keyof T, order: "ASC" | "DESC" = "ASC"): T[] {
    if (!data.length) return data;

    if (order === "ASC") {
      return [...data].sort((a, b) => {
        if (a[prop] < b[prop]) return -1;
        if (a[prop] > b[prop]) return 1;
        return 0;
      });
    } else {
      return [...data].sort((a, b) => {
        if (a[prop] > b[prop]) return -1;
        if (a[prop] < b[prop]) return 1;
        return 0;
      });
    }
  }
}
